import { useEffect, useState } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useTimeZone } from '../../../../hooks'
import { getMockCalendarDayLoad } from '../../Calendar.mock'

import { getCalendarDayLoadState } from './useCalendarDayLoad.utils'

export function useCalendarDayLoad(date) {
  const timezone = useTimeZone()

  const [response, setResponse] = useState(EMPTY_OBJECT)

  // TODO: read the load from the day-load endpoint once the backend serves
  // it.
  async function readDayLoad(signal) {
    return getMockCalendarDayLoad({ date, timezone })
      .then(({ data }) => {
        if (!signal.aborted) {
          setResponse({ date, dayLoad: data, isFailed: false })
        }
      })
      .catch(() => {
        if (!signal.aborted) {
          setResponse({ date, dayLoad: null, isFailed: true })
        }
      })
  }

  useEffect(() => {
    if (date) {
      const abortController = new AbortController()

      readDayLoad(abortController.signal)

      return () => {
        abortController.abort()
      }
    }
  }, [date, timezone])

  return getCalendarDayLoadState({ date, response })
}
